import * as React from 'react';
import {option, Option} from "ts-option";
import {EditableProps} from "../../common/props/EditableProps";
import {DisableableProps} from "../../common/props/DisableableProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import {PressableProps} from "../../common/props/PresableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import RangeNumberInput from "../../../hiberUiKit/src/atoms/Input/RangeNumberInput";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * Min input value.
	 */
	minValue?: number,
	/**
	 * Max input value.
	 */
	maxValue?: number,
	/**
	 * Max number of decimal places allowed.
	 */
	maxDecimalPlaces?: number;
}

type Props =
	DisableableProps
	& EditableProps
	& FocusableProps
	& PressableProps
	& FormGroupProps<number>
	& PlaceholderProps
	& ComponentProps

export default class RangeNumberInputFormGroup extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<div className={"input-group"}>
					<RangeNumberInput onChange={this.onChange}
									  value={this.props.field.value}
									  minValue={option(this.props.minValue)}
									  maxValue={option(this.props.maxValue)}
									  placeholder={this.props.placeholder}
									  disabled={this.props.disabled}
									  focus={this.props.focus}
									  onFocus={this.props.onFocus}
									  onEnter={this.props.onEnter}
									  readonly={this.props.readonly}
									  maxDecimalPlaces={this.props.maxDecimalPlaces}/>
				</div>
			</FormGroup>
		);
	}

	/**
	 * On change action.
	 * @param {Option<number>} value Value of the percent input.
	 */
	onChange(value: Option<number>) {
		this.props.onChange(this.props.field.updateValue(value))
	}
}